import BaseRepository from "./BaseRepository";
import ProductCompareAPICall from "../service/ProductCompareAPICall";
import ProductCompare from "../model/ProductCompare";
import Helper from "../support/Helper";
import store from "../storeWire";
import System from "../helper/system";
import { __set, __remove } from "src/store/axios_indicator";

class ProductCompareRepository extends BaseRepository {
    LOCAL_STORAGE_NAME = 'PRODUCT_COMPARE';
    fetchAllData = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        let res = await new ProductCompareAPICall().getAll();
        new ProductCompare().setData(res);
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
    toggleSingleProduct = async (data) => {
        let dataHere = {};
        let state = store.getState();
        if (state.entities.model_ProductCompare.data !== undefined && Object.entries(state.entities.model_ProductCompare.data).length > 0) {
            dataHere = JSON.parse(JSON.stringify(state.entities.model_ProductCompare.data));
        }
        if (dataHere[data.ItemNumber] !== undefined && dataHere[data.ItemNumber]) {
            delete dataHere[data.ItemNumber];
            let res = await new ProductCompareAPICall().setAll(dataHere);
            return res;
        } else {
            let dd = {
                ItemNumber: data.ItemNumber,
                ManufacturerPartNumber: data.ManufacturerPartNumber,
                ERPMFRPartNumber: data.ERPMFRPartNumber,
                PartNumber: data.ERPMFRPartNumber,
                Quantity: data.QtyMin,
                QtyMin: data.QtyMin,
                QtyMult: data.QtyMult,
                Min: data.QtyMin,
                Mult: data.QtyMult,
                // DataSheet: Helper.valueIsNotNull(data.ManufacturerDatasheetURL) ?  data.ManufacturerDatasheetURL : data?.IHSManufacturerDatasheetURL,
                DatasheetUrl: data.DatasheetUrl,
                Manufacturer: data.ManufacturerName,
                ManufacturerName: data.ManufacturerName,
                ItemRowNumber: data.ItemRowNumber,
                AssetURL: data.AssetURL,
                ERPManufacturerName: data.ERPManufacturerName,
                ObsoleteFlag: data.ObsoleteFlag,
                ERPManufacturerCode: data.ERPManufacturerCode,
                WebCode: data.WebCode,
                Attributes: data.Attributes,
                CustomerPartNumbers: data.CustomerPartNumbers,
                LifeCycleRisk: data.LifeCycleRisk,
                ROHSCompliantCodeValue: data.ROHSCompliantCodeValue,
                ROHSCompliantCode: data.ROHSCompliantCode,
                PackagingTypeCode: data.PackagingTypeCode,
                WebOnlyFlag: data.WebOnlyFlag,
                NPIFlag: data.NPIFlag,
                TopSellerFlag: data.TopSellerFlag,
                EndOfLifeFlag: data.EndOfLifeFlag,
                EndOfLifeOFlag: data.EndOfLifeFlag,
                ManufacturerCode: data.ManufacturerCode,
                NCNRFlag: data.NCNRFlag,
                IsDesignsAvailable: data.IsDesignsAvailable,
                ShortDescription: data.ShortDescription, // DT
                StructureHierarchy: data.StructureHierarchy,
                ERPPartNumberModified: data?.ERPPartNumberModified,
                FarnellInventorySharing: data?.FarnellInventorySharing
            };
            if (data.ERPPartNumber !== undefined && data.ERPPartNumber) {
                dd.ERPPartNumber = data.ERPPartNumber;
            }
            dataHere[data.ItemNumber] = dd;
        }
        if (Object.entries(dataHere).length >= 11) {
            // Ticket #  : 12849
            // Change #  : Removed message which is showing in the PLP Screen
            // Date      : 12 July,2023
            // Change by : PN
            //System.alert('Part cannot be added. Product compare is limited to 10 parts.', 'danger');
            return {};
        }
        let res = await new ProductCompareAPICall().setAll(dataHere);
        this.fetchAllData();
        return res;
    };
    removeAll = async () => {
        await new ProductCompareAPICall().removeAll();
        await new ProductCompare().removeAll();
    };
    getSessionUUID = () => {
        let c = System.getParams();
        if (c.productCompareUUID && c.productCompareUUID.length > 1) {
            return c.productCompareUUID;
        }
        return this.setUUIDOnKey('sessionUUID');
    };
    setValueToCompareProduct = (key, value) => {
        let CompareProduct = localStorage.getItem(this.LOCAL_STORAGE_NAME);
        if (CompareProduct) {
            CompareProduct = JSON.parse(CompareProduct);
        } else {
            CompareProduct = {}
        }
        CompareProduct[key] = value;
        localStorage.setItem(this.LOCAL_STORAGE_NAME, JSON.stringify(CompareProduct));
        return this.getValueFromCompareProduct(key);
    };
    setUUIDOnKey = (key) => {
        let l = this.getValueFromCompareProduct(key);
        if (l) {
            return l;
        }
        l = Helper.UUID();
        return this.setValueToCompareProduct(key, l);
    };
    getValueFromCompareProduct = (key) => {
        let l = this.getCompareProduct([key]);
        if (l[key] === undefined) {
            return false;
        }
        return l[key];
    };
    getCompareProduct = () => {
        let CompareProduct = localStorage.getItem(this.LOCAL_STORAGE_NAME);
        if (CompareProduct) {
            CompareProduct = JSON.parse(CompareProduct);
        } else {
            CompareProduct = {}
        }
        return CompareProduct;
    };
}

export default ProductCompareRepository;